/* Klaviyo onsite popup governance — frequency cap + ghost overlay cleanup.
   Popup timing/targeting remain in Klaviyo admin; this script adds theme-side guardrails. */
(function () {
  "use strict";

  var SNOOZE_KEY = "zeus:klaviyo-popup-dismissed";
  var SNOOZE_DAYS = 7;
  var AXEPTIO_MODAL_ID = "axeptio_main_modal";
  /* Presence de la cle, pas sa valeur : un refus total ecrit le cookie avec une
     charge utile vide, et tester la valeur bloquerait la popup a vie. */
  var AXEPTIO_COOKIE_RE = /(?:^|;\s*)axeptio_authorized_vendors\s*=/;
  /* Selecteur volontairement etroit : [class*='axeptio'] matchait tout le DOM
     Axeptio (qui s'anime en continu) et relancait un scan a chaque frame. */
  var AXEPTIO_NODE_SELECTOR = "#axeptio_main_modal, [class*='axeptio_widget'], [class*='axeptio_overlay']";
  /* Proprietes que ce script pilote en inline !important. Tracees par root pour
     pouvoir les relacher sans toucher aux styles inline poses par Klaviyo. */
  var MANAGED_STYLES = { display: "none", visibility: "hidden", "pointer-events": "none" };
  var POPUP_OPEN_CLASS = "zeus-klaviyo-popup-open";
  var POPUP_CANDIDATE_SELECTOR = [
    "[class*='kl-private'][role='dialog']",
    "form[class*='kl-private']",
    "div[data-testid='klaviyo-form']",
    ".klaviyo-form.klaviyo-form-version-cid",
  ].join(",");
  var KLAVIYO_NODE_SELECTOR = [
    "[class*='kl-private']",
    "[class*='klaviyo']",
    "[class*='kl-teaser']",
    "[data-testid='klaviyo-form']",
    "[data-zeus-klaviyo-popup-root]",
  ].join(",");

  function isSnoozed() {
    try {
      var raw = localStorage.getItem(SNOOZE_KEY);
      if (!raw) return false;
      var days = (Date.now() - parseInt(raw, 10)) / 86400000;
      return days < SNOOZE_DAYS;
    } catch (e) {
      return false;
    }
  }

  function snooze() {
    try {
      localStorage.setItem(SNOOZE_KEY, Date.now().toString());
    } catch (e) {
      /* Storage blocked — governance still runs, snooze just won't persist. */
    }
    document.documentElement.setAttribute("data-zeus-klaviyo-snoozed", "true");
    syncPopupState(findPopupRoots(), true);
  }

  function elementTouchesKlaviyo(node) {
    if (!node || node.nodeType !== 1) return false;
    return node.matches(KLAVIYO_NODE_SELECTOR) || Boolean(node.querySelector(KLAVIYO_NODE_SELECTOR));
  }

  /* Signal deterministe du SDK Axeptio, plus fiable que le sniffing DOM/cookie.
     Bascule a true des que l'utilisateur a repondu (accepte OU refuse). */
  var axeptioChoiceMade = false;
  var requestScan = null;

  function hasAxeptioChoice() {
    try {
      return axeptioChoiceMade || AXEPTIO_COOKIE_RE.test(document.cookie);
    } catch (e) {
      /* Cookies illisibles : on considere le choix fait pour ne jamais rester bloque. */
      return true;
    }
  }

  function hasAxeptioWidget() {
    return Boolean(
      document.getElementById(AXEPTIO_MODAL_ID) ||
      document.querySelector("[class*='axeptio_widget']") ||
      document.querySelector("[class*='axeptio'][class*='modal']"),
    );
  }

  /* Axeptio consent pending = consent not yet given OR its widget is still open.
     While pending, the Klaviyo popup must stay suppressed (single-overlay rule). */
  function isAxeptioPending() {
    return hasAxeptioWidget() && !hasAxeptioChoice();
  }

  function watchAxeptioSdk() {
    try {
      window._axcb = window._axcb || [];
      window._axcb.push(function (sdk) {
        if (!sdk || typeof sdk.on !== "function") return;
        sdk.on("cookies:complete", function () {
          axeptioChoiceMade = true;
          if (requestScan) requestScan();
        });
      });
    } catch (e) {
      /* SDK absent ou bloque : le fallback cookie + DOM reste en place. */
    }
  }

  function mutationTouchesKlaviyo(mutations) {
    return mutations.some(function (mutation) {
      if (elementTouchesKlaviyo(mutation.target)) return true;

      return (
        Array.prototype.some.call(mutation.addedNodes, elementTouchesKlaviyo) ||
        Array.prototype.some.call(mutation.removedNodes, elementTouchesKlaviyo)
      );
    });
  }

  function findPopupRoots() {
    /* Contrat d'ordre : on relache TOUS nos overrides avant la moindre mesure.
       Un root laisse en display:none mesure 0x0, se fait eliminer par le seuil de
       taille plus bas, n'entre donc jamais dans roots -> plus personne ne le
       relache et la popup reste morte pour la pageview. La liberation doit aussi
       etre globale ([data-zeus-klaviyo-managed]) et pas limitee aux roots trouves,
       pour la meme raison. */
    releaseManagedStyles();

    var roots = [];

    document.querySelectorAll(POPUP_CANDIDATE_SELECTOR).forEach(function (node) {
      // Teasers share Klaviyo's private reset classes with forms but never take over the page.
      if (node.closest("[class*='kl-teaser']")) return;
      var root = node.closest("[role='dialog']");
      var current = node;

      while (!root && current && current !== document.body) {
        if (window.getComputedStyle(current).position === "fixed") root = current;
        current = current.parentElement;
      }

      if (!root || roots.indexOf(root) !== -1) return;
      var rect = root.getBoundingClientRect();
      if (rect.width <= 120 || rect.height <= 80) return;
      roots.push(root);
    });

    return roots;
  }

  /* Snapshot des declarations inline VENDEUR avant notre premier override, pour
     pouvoir les restaurer a l'identique (valeur + priority) quand on relache.
     Sans ce snapshot, removeProperty supprimerait aussi le style inline que
     Klaviyo avait pose lui-meme avant nous (review Codex PR #345). */
  var originalInline = new WeakMap();

  function captureOriginals(root) {
    if (originalInline.has(root)) return;
    var snapshot = {};
    Object.keys(MANAGED_STYLES).forEach(function (prop) {
      snapshot[prop] = {
        value: root.style.getPropertyValue(prop),
        priority: root.style.getPropertyPriority(prop),
      };
    });
    originalInline.set(root, snapshot);
  }

  function restoreOriginal(root, prop) {
    var snap = originalInline.get(root);
    var orig = snap && snap[prop];
    if (orig && orig.value) {
      root.style.setProperty(prop, orig.value, orig.priority);
    } else {
      root.style.removeProperty(prop);
    }
  }

  /* Pose/retire nos overrides inline. On ne retire QUE ce qu'on a pose nous-memes
     (trace dans data-zeus-klaviyo-managed) pour ne pas ecraser les styles inline
     que Klaviyo applique lui-meme a son formulaire. */
  function setManagedStyles(root, props) {
    captureOriginals(root);
    var previous = (root.getAttribute("data-zeus-klaviyo-managed") || "").split(",").filter(Boolean);

    previous.forEach(function (prop) {
      if (props.indexOf(prop) === -1) restoreOriginal(root, prop);
    });
    props.forEach(function (prop) {
      root.style.setProperty(prop, MANAGED_STYLES[prop], "important");
    });

    if (props.length) {
      root.setAttribute("data-zeus-klaviyo-managed", props.join(","));
    } else {
      root.removeAttribute("data-zeus-klaviyo-managed");
      originalInline.delete(root);
    }
  }

  /* Relache nos overlays inline partout ou ils sont poses. Appele par
     findPopupRoots avant toute mesure : sinon getComputedStyle relit notre propre
     visibility:hidden, le popup est vu comme "hidden" a chaque scan et reste
     masque a vie (auto-verrouillage). Aucun repaint entre relache et repose :
     tout se joue dans le meme tour synchrone. */
  function releaseManagedStyles() {
    document.querySelectorAll("[data-zeus-klaviyo-managed]").forEach(function (root) {
      setManagedStyles(root, []);
    });
  }

  /* Ghost nodes traites au scan precedent : on relache leur pointer-events avant
     de re-poser, sinon un ghost devenu popup reelle resterait inerte au clic
     (le style n'etait jamais retire). */
  var managedGhosts = [];

  function releaseGhostStyles() {
    managedGhosts.forEach(function (node) {
      node.style.removeProperty("pointer-events");
    });
    managedGhosts = [];
  }

  /* Attend un tableau issu de findPopupRoots (qui a donc deja relache les
     overrides et mesure une geometrie reelle). */
  function syncPopupState(roots, snoozed) {
    releaseGhostStyles();

    var rootStates = roots.map(function (root) {
      var style = window.getComputedStyle(root);
      var opacity = parseFloat(style.opacity || "1");
      var hidden =
        style.display === "none" ||
        style.visibility === "hidden" ||
        opacity < 0.05 ||
        root.getAttribute("aria-hidden") === "true";

      return {
        root: root,
        hidden: hidden,
        open: !hidden && opacity > 0.2,
      };
    });
    var ghostNodes = [];

    document.querySelectorAll("[class*='kl-private']").forEach(function (node) {
      if (node.closest(".klaviyo-form")) return;
      var rect = node.getBoundingClientRect();
      if (rect.width < 2 && rect.height < 2) return;
      var style = window.getComputedStyle(node);
      var coversViewport = rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9;
      if (coversViewport && (parseFloat(style.opacity || "1") < 0.12 || style.visibility === "hidden")) {
        ghostNodes.push(node);
      }
    });

    rootStates.forEach(function (state) {
      var props = [];

      state.root.setAttribute("data-zeus-klaviyo-popup-root", "true");
      if (state.hidden || snoozed) {
        props.push("pointer-events", "visibility");
      }
      if (snoozed) {
        props.push("display");
      }
      /* props vide => suppression levee (consentement donne, snooze expire) :
         setManagedStyles relache tout et le formulaire peut enfin s'afficher. */
      setManagedStyles(state.root, props);
    });
    ghostNodes.forEach(function (node) {
      node.style.setProperty("pointer-events", "none", "important");
      managedGhosts.push(node);
    });

    var open =
      !snoozed &&
      rootStates.some(function (state) {
        return state.open;
      });
    document.documentElement.classList.toggle(POPUP_OPEN_CLASS, open);
    if (window.ZeusOverlayLock) window.ZeusOverlayLock.sync();
  }

  /* Axeptio injecte un conteneur dont la modale est un descendant : tester le seul
     noeud ajoute (matches) ratait l'insertion. On teste aussi les descendants. */
  function elementTouchesAxeptio(node) {
    if (!node || node.nodeType !== 1) return false;
    return node.matches(AXEPTIO_NODE_SELECTOR) || Boolean(node.querySelector(AXEPTIO_NODE_SELECTOR));
  }

  function mutationTouchesAxeptio(mutations) {
    return mutations.some(function (mutation) {
      if (elementTouchesAxeptio(mutation.target)) return true;

      return (
        Array.prototype.some.call(mutation.addedNodes, elementTouchesAxeptio) ||
        Array.prototype.some.call(mutation.removedNodes, elementTouchesAxeptio)
      );
    });
  }

  function suppressIfNeeded() {
    var snoozed = isSnoozed();
    document.documentElement.toggleAttribute("data-zeus-klaviyo-snoozed", snoozed);
    return snoozed;
  }

  function bindDismissHandlers(root) {
    root.querySelectorAll("button, [role='button'], a").forEach(function (btn) {
      if (btn.dataset.zeusKlaviyoBound) return;
      var label = (btn.getAttribute("aria-label") || btn.textContent || "").toLowerCase();
      if (
        label.indexOf("close") === -1 &&
        label.indexOf("fermer") === -1 &&
        label.indexOf("dismiss") === -1 &&
        label !== "×" &&
        label !== "x"
      ) {
        return;
      }
      btn.dataset.zeusKlaviyoBound = "true";
      btn.addEventListener(
        "click",
        function () {
          snooze();
        },
        { capture: true },
      );
    });
  }

  function scan() {
    var snoozed = suppressIfNeeded();
    var axeptioPending = isAxeptioPending();
    var roots = findPopupRoots();

    if (!snoozed && !axeptioPending) roots.forEach(bindDismissHandlers);
    syncPopupState(roots, snoozed || axeptioPending);
  }

  function init() {
    var observer;
    var idleScanId;
    var scanTimer;
    var pageLoaded = document.readyState === "complete";
    var observerConfig = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "hidden", "open"],
    };

    function runScan() {
      idleScanId = undefined;
      scanTimer = undefined;
      observer.disconnect();
      scan();
      observer.observe(document.body, observerConfig);
    }

    function scheduleScan() {
      if (!pageLoaded || idleScanId !== undefined || scanTimer !== undefined) return;

      if (typeof window.requestIdleCallback === "function") {
        idleScanId = window.requestIdleCallback(runScan, { timeout: 1000 });
      } else {
        scanTimer = window.setTimeout(runScan, 100);
      }
    }

    requestScan = scheduleScan;
    watchAxeptioSdk();

    suppressIfNeeded();
    observer = new MutationObserver(function (mutations) {
      if (mutationTouchesKlaviyo(mutations) || mutationTouchesAxeptio(mutations)) scheduleScan();
    });
    observer.observe(document.body, observerConfig);
    document.addEventListener("zeus:decision-context-change", scheduleScan);

    window.addEventListener(
      "pageshow",
      function () {
        suppressIfNeeded();
        scheduleScan();
      },
      { passive: true },
    );

    if (pageLoaded) {
      scheduleScan();
    } else {
      window.addEventListener(
        "load",
        function () {
          pageLoaded = true;
          scheduleScan();
        },
        { once: true, passive: true },
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
